import Header from './components/Header'
import HomePage from './components/pages/HomePage'
import Footer from './components/Footer'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Policy from "./components/pages/PolicyAndTerms/Policy";
import Terms from "./components/pages/PolicyAndTerms/Terms";

const App = () => {
  return (
    <BrowserRouter>
      <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
